// extracted by mini-css-extract-plugin
export default {"container":"Main_container__gnYjG","content":"Main_content__9jHCG","header":"Main_header__qDpuG","box":"Main_box__ZBOIB"};